import { render } from "./VerificationStatusFailed.vue?vue&type=template&id=726b6d6a&ts=true"
import script from "./VerificationStatusFailed.vue?vue&type=script&lang=ts"
export * from "./VerificationStatusFailed.vue?vue&type=script&lang=ts"

import "./VerificationStatusFailed.vue?vue&type=style&index=0&id=726b6d6a&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/transaction/VerificationStatusFailed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "726b6d6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('726b6d6a', __exports__)) {
    api.reload('726b6d6a', __exports__)
  }
  
  module.hot.accept("./VerificationStatusFailed.vue?vue&type=template&id=726b6d6a&ts=true", () => {
    api.rerender('726b6d6a', render)
  })

}


export default __exports__